export default {
  requestCode: {
    jzz: 'Loading',
    qzsb: 'Request failed, please try later. Contact support if needed.',
    dlsxqcxdl: 'Login expired, please re-login',
    dlsxqcxjr: 'Login expired, please re-enter',
    fwqzwxyqshzs: 'Server not responding, please try later.',
  },
  backStep: 'Previous',
  nextStep: 'Next',
  submit: 'Submit',
  noAllowEmpty: 'Cannot be empty',
  bxxbnwk: 'Required field cannot be empty',
  confirm: 'Confirm',
  cancel: 'Cancel',
  mmcw: 'Wrong password',
  reset: 'Reset',
  success: 'Completed',
  Understood: 'Understood',
  close: 'Close',
  service: 'Contact Support',
  backOpen: 'Back to Open',
  Step: {
    xxyz: 'Info Verification',
    fxpl: 'Risk Disclosure',
    rlyz: 'Face Verification',
    rjrz: 'Deposit Certification',
    vytzzrz: 'Professional Certification',
  },
  AudioPlayer: {
    cpdb: 'Licensed Rep:',
    pzh: 'License No.',
    bs: 'Speed',
    yue: 'About',
    fen: 'Min',
    miao: 'Sec',
  },
  CheckBoxList: {
    wyjydjmb: 'I have read and understood',
    khxys: 'Client Agreement',
    khsqqrs: 'Client Authorization',
    nr: 'Content;',
  },
  CountryPopup: {
    qsrdqgjzss: 'Enter region keyword to search',
    cydq: 'Common Regions',
  },
  Investment: {
    ynyx: 'Less than 1 year',
    yzhiwunian: '1-5 years',
    liuzhishinian: '6-10 years',
    shinianyishang: 'Over 10 years',
    baoben: 'Capital Protection',
    zczz: 'Asset Growth',
    gxhb: 'Dividend Return',
    duichong: 'Hedging',
    tl: 'Arbitrage',
    touji: 'Speculation',
    wyyjxyspmm: 'I intend to trade derivatives',
    simple: {
      wyyjxyspmm:
        'I intend to trade derivatives and understand the risks involved in derivative trading',
    },
    wwyjxyspmm: 'I do not intend to trade derivatives',
    jrjgjbdyspjz: 'Derivatives seminar by financial institutions.',
    jyjgjbyspwskc: 'Derivatives online or classroom courses by educational institutions.',
    yhxtgs: 'Bank/Trust Company',
    zqqhqq: 'Securities/Futures/Options',
    jjzgjz: 'Fund/Asset Mgmt/Family Office',
    jysjrhyxh: 'Exchange/Financial Association',
    bxgs: 'Insurance Company',
    ysqz: 'Warrants',
    nxz: 'Bull/Bear Certificates',
    qhhqq: 'Futures and Options',
    gpggpj: 'Equity-Linked Notes',
    yq: 'Forward',
    dqhh: 'Swap',
    tzjy: 'Investment Experience',
    gptzjy: 'HK Listed Stock Experience',
    jytzjy: 'Gold/Silver Investment Experience',
    whjsptzjy: 'FX/Commodity Investment Experience',
    agtzjy: 'A-Share Investment Experience',
    jjtzjy: 'Fund Investment Experience',
    tzmddx: 'Investment Purpose',
    khxys: 'Client Agreement',
  },
  DerivativeModel: {
    yspmm: 'Derivatives Trading',
    nsfljyscpdzytcjfx: 'Do you understand the main features and risks of derivatives?',
    wmbybyscpdzytzqlj:
      'I understand the main features of derivatives and the risks involved in trading.',
    nxyzsyyyxyscpxgjy: 'You need at least one derivative-related experience (multiple)',
    wcjsygjsyscpzxzjfxdpxhkc: 'I have attended training or courses on derivatives and their risks.',
    wxshgwdgzjyywyyscpyg: 'My current or past work/business involves derivatives.',
    wxshgwdgzjyywyyscpygyqxgzy:
      'My current or past work/business involves derivatives. Related roles and nature:',
    wxshgwdyyscpygdgzjyywdfwnqw:
      'My current or past derivative-related work/business service period:',
    wymmyscpdjymmgdyscps: 'I have traded derivatives. Traded derivatives include:',
    yscpbkdbxyysqcnxzgpzsqh:
      'Derivatives include but are not limited to warrants, bull/bear certificates, stock/index futures and options, commodity structured products, and ETFs, whether traded on exchanges or not.',
    nyqrwytzyscpbckh:
      'You have confirmed no intention to invest in derivatives. Derivative trading will not be activated.',
  },
  SimpleDerivative: {
    title: 'Do you intend to trade derivatives?',
    yspmm: 'Derivatives Trading',
    nsfljyscpdzytcjfx: 'Do you understand the main features and risks of derivatives?',
    wmbybyscpdzytzqlj:
      'I understand the main features of derivatives and the risks involved in trading.',
    nxyzsyyyxyscpxgjy: 'Please select your derivative-related experience',
    wcjsygjsyscpzxzjfxdpxhkc: 'I have attended training or courses on derivatives and their risks.',
    wxshgwdgzjyywyyscpyg: 'My current or past work/business involves derivatives.',
    wxshgwdgzjyywyyscpygyqxgzy:
      'My current or past work/business involves derivatives. Related roles and nature:',
    wxshgwdyyscpygdgzjyywdfwnqw:
      'My current or past derivative-related work/business service period:',
    wymmyscpdjymmgdyscps: 'I have traded derivatives.',
    yscpbkdbxyysqcnxzgpzsqh:
      'Derivatives include but are not limited to warrants, bull/bear certificates, stock/index futures and options, commodity structured products, and ETFs, whether traded on exchanges or not.',
    nyqrwytzyscpbckh:
      'You have confirmed no intention to invest in derivatives. Derivative trading will not be activated.',
    errorInfo:
      'To activate derivative trading, at least one derivative-related experience must be selected',
    openText: 'Activate Derivative Trading',
  },
  UploadFile: {
    scz: 'Uploading...',
    jzz: 'Loading...',
    scsbqcs: 'Upload failed, please retry',
    xztp: 'Select Image',
    wjcgzdxz: 'File exceeds size limit',
    zctpyupdf: 'Supports PDF and images',
  },
  fxhlkh: 'Fosun International Securities Account Opening',
  idCardTip: {
    photoTips: {
      title: 'Photo Tips',
      des: 'Ensure full ID border, clear text, and even lighting without glare',
    },
    photoError: {
      standard: 'Standard',
      missing: 'Border Missing',
      vague: 'Blurry Info',
      reflex: 'Glare',
    },
  },
  passwordError: 'Wrong Password',
  tradeDialog: {
    title: 'Enter Trading Password',
    sure: 'Confirm',
    tip: '8-20 digits or letters',
    passwordVerification: 'Trading Password Verification',
    forgotPassword: 'Forgot Password',
    noticeText: 'Current account type does not support this feature. Contact Fosun Wealth Support.',
    freezeText: 'Account frozen, contact support',
    toastFreezeText: 'Submission failed! Account frozen, contact support.',
  },
  complianceTips: 'Securities services provided by Fosun International Securities',
  firstLoginTips: 'First login with phone number will auto-register account',
  loading: 'Loading...',
  djsc: 'Click to Upload',
  nyjxzgdqtp: 'You have selected this image',
  scz: 'Uploading',
  yhmc: 'Bank Name',
  zceddakjrj: 'Supports eDDA Quick Deposit',
  zcqtrjfs: 'Supports Other Deposit Methods',
  复星国际证券: 'Fosun International Securities',
  noticeBarTip: 'Read agreements and authorize for normal trading',
  toAuth: 'Authorize',
  identifyTitle: 'Important Reminder',
  identifyText2:
    'You have completed HK Investor ID authorization. Account will unlock next business day.',
  questText: 'For questions, please',
  toSign: 'Sign Now',
  lookDetail: 'View Details',
  submitError: 'Submission Failed',
  openBtn: 'Open Account Now',
  openTip: 'Account not opened, cannot subscribe to new shares',
  setPasswordBtn: 'Set Trading Password',
  setPasswordTip: 'Trading password not set, cannot subscribe to new shares',
  repeatSendCodeTips: 'No need to resend code within 60s',
  千: 'Thousand',
  万: 'Ten Thousand',
  十万: 'Hundred Thousand',
  百万: 'Million',
  千万: 'Ten Million',
  亿: 'Hundred Million',
  十亿: 'Billion',
  signAuthTip: 'Confirm authorization and retry',

  伴您财富乘长: 'Grow Your Wealth with Us',
  下载: 'Download',
  downloadNow: 'Download Now',
  mainlandService: 'Mainland Support',
  hkService: 'HK Support',

  LivingWitness: {
    rlyz: 'Face Verification',
    qasldzpsydsmbrmbsp: 'Record a 3-second facial video as shown',
    shili: 'Example',
    banshenzhengmian: 'Half-Body Front Video',
    paishetishi: 'Shooting Tips',
    qbzmbwz: 'Ensure full face and good lighting;',
    spschrbmykcxps: 'If unsatisfied after upload, retake video',
    dqllqbbbzcsxtqqhllq: 'Current browser does not support camera, switch browser',
    yzsbqcxyz: 'Verification failed, please retry',
    lzspsbqcxlz: 'Recording failed, please retry',
    qzydddkym: 'Please open on mobile',
    rlyztg: 'Face Verification Passed',
    spwjgdqcxsc: 'Video file too large, please re-upload',
    htsbtp: 'Liveness Detection Image',
    videoShortMsg: 'Video too short, please re-upload',
    videoLongMsg: 'Video too long, please re-upload',
  },

  tishi: 'Notice',
  submitSuccess: 'Submission Successful',
  我已确认自愿签署: 'I confirm voluntary signing',
  yzmfssb: 'Verification code send failed',
  ucAuthLogout: 'Log out',
  ucAuthLoginExtra: 'This account needs additional verification. Please sign in with the mobile app.',
  '《复星国际证券有限公司客户说明文件》':
    '《Fosun International Securities Limited Client Information Document》',
  复星国际证券有限公司客户说明文件:
    'Fosun International Securities Limited Client Information Document',
  enterpriseWechatCustomerService: 'Enterprise WeChat Customer Service',
  generatingQrCode: 'Generating QR Code...',
  qeCodeGenerationFailed: 'QR Code Generation Failed',
  longPressQRCode: 'Long Press QR Code to Save',
  longPressNotRecognized: 'Long Press Not Recognized?',
  longPressTip:
    'Please long press to save the QR code to your phone album, open WeChat and use the scan function, select the QR code image you just saved from the album to scan, and you can successfully join the group chat.',
  hkCustomerServiceHotline: 'Hong Kong Customer Service Hotline',
  mainlandCustomerServiceHotline: 'Mainland Customer Service Hotline',
  weChatBusiness: 'Enterprise WeChat',
  relatedInquiriesPleaseContactCustomerService:
    'For related inquiries, please contact customer service',
  ContactCustomerService: 'Contact Customer Service',
  customerService: 'Customer Service Hotline',
  bzcxskf:
    'Sorry, the currently selected country/region does not support online opening of accounts, if you need to apply for offline processing.',
  xxcl: 'Please contact customer service.',
  bzcxskfxg:
    'Sorry, the currently selected country/region does not support online modification of account information, if you need to apply for offline processing.',
  sendPage: {
    srdxyzm: 'Enter SMS code',
    yfsdxyzmz: 'SMS code sent to:',
    cxfs: 'Resend',
    sbdyzm: 'Didn‘t receive code',
    nkylxkfjxyzmcx: 'Contact CS for code inquiry.',
    dlkf: 'Mainland CS:',
    xgkf: 'Hong Kong CS:',
    qsrzqdyzmzsyc: 'Invalid or expired code, try again',
    zdl: 'Got it',
    获取语音验证码: 'Get voice code',
    '我们将通过电话语音告知您验证码，请留意接听。': 'We will call with code, please answer.',
    '如仍无法收到，可': 'If still not received,',
    联系客服: 'contact CS',
    '语音验证码已发送，请留意接听电话': 'Voice code sent, please answer.',
    重新获取: 'Resend',
    输入语音验证码: 'Enter voice code',
    我们正在打电话至: 'Calling:',
    电话将提供验证码: ', will provide code',
    '语音验证码获取频率过高，请稍后再试': 'Voice code request too frequent, try later.',
    联系我们: 'Contact us',
  },
}
